import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Form from 'react-bootstrap/Form';
import FormAlert from 'components/Forms/FormAlert';
import AuthService from 'services/auth';
import { setGames } from 'actions/auth';
import DotLoader from 'components/Utlility/DotLoader';
import styles from './RedeemCodeModal.module.scss';

const RedeemCodeModal = ({ onClose, prefillCode = '' }) => {
    const dispatch = useDispatch();
    const room = useSelector(state => state.room);
    const [show, setShow] = useState(false);
    const [code, setCode] = useState(prefillCode);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [codeRedeemed, setCodeRedeemed] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [game, setGame] = useState(null);

    useEffect(() => {
        setTimeout(() => setShow(true), 10);
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleClose = () => {
        setShow(false);
        setTimeout(() => {
            onClose(codeRedeemed);
        }, 500);
    };

    const checkVoucher = async (e) => {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        setMessage('');
        setError(false);

        const res = await AuthService.checkCode(code);
        if (res.status === 'Success') {
            setLoading(false);
            setGame(res.game);
            setShowConfirmation(true);
        } else {
            setLoading(false);
            setMessage(res.message);
            setError(true);
        }
    };

    const redeemCode = async () => {
        setLoading(true);
        setShowConfirmation(false);

        try {
            const response = await AuthService.redeemCode(code);
            const msg = response.message || response.message.toString();

            if (response.status === 'Error') {
                setLoading(false);
                setMessage(msg);
                setError(true);
                setCode('');
            } else {
                dispatch(setGames(response.games));
                if (room.roomOpen && room.room) {
                    room.room.send('refresh_lobby_games', {});
                }
                setLoading(false);
                setMessage(msg);
                setError(false);
                setCode('');
                setCodeRedeemed(true);
            }
        } catch (err) {
            const errorMsg = (err.response?.data?.message) || err.message || err.toString();
            setLoading(false);
            setMessage(errorMsg);
            setError(true);
            setCode('');
        }
    };

    return (
        <div className={`${styles.screenOverlay} ${show ? styles.show : ''}`}>
            <div className={styles.screenOverlayBG} onClick={handleClose}></div>
            <div className={styles.modalContainer}>
                <div className={styles.modal}>
                    <button className={styles.closeButton} onClick={handleClose}>
                        &times;
                    </button>

                    <h1>Redeem Code</h1>

                    <div className={styles.content}>
                        {showConfirmation ? (
                            <div className={styles.confirmation}>
                                <p>Are you sure you want to activate?</p>
                                <div className={styles.gameName}>{game?.name}</div>
                                <div className={styles.buttonGroup}>
                                    <button
                                        onClick={() => setShowConfirmation(false)}
                                        className={`${styles.button} ${styles.small} ${styles.alternate}`}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={redeemCode}
                                        className={`${styles.button} ${styles.small}`}
                                    >
                                        {loading ? <DotLoader size="medium" variant="light" /> : 'Activate'}
                                    </button>
                                </div>
                            </div>
                        ) : codeRedeemed ? (
                            <div className={styles.success}>
                                <FormAlert variant="success">{message}</FormAlert>
                                <p>Your code has been redeemed successfully!</p>
                                <div className={styles.buttonGroup}>
                                    <button
                                        onClick={() => {
                                            setCodeRedeemed(false);
                                            setMessage('');
                                        }}
                                        className={`${styles.button} ${styles.small}`}
                                    >
                                        Redeem Another
                                    </button>
                                    <button
                                        onClick={handleClose}
                                        className={`${styles.button} ${styles.small} ${styles.alternate}`}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <Form onSubmit={checkVoucher}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Activation Code</Form.Label>
                                    <Form.Control
                                        type="text"
                                        autoComplete="off"
                                        placeholder="Enter your activation code"
                                        required
                                        onChange={(e) => setCode(e.target.value)}
                                        value={code}
                                    />
                                </Form.Group>

                                <FormAlert variant={error ? 'danger' : 'success'}>{message}</FormAlert>

                                <div className={styles.buttonGroup}>
                                    <button
                                        type="submit"
                                        className={`${styles.button} ${styles.small}`}
                                        disabled={loading}
                                    >
                                        {loading ? <DotLoader size="medium" variant="light" /> : 'Submit'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RedeemCodeModal;
